import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Table, TableContainer, TableHead, TableRow, TableBody, TableCell } from '@material-ui/core'

class PeriodoPresupuestarioImportarReporte extends Component {
    render() {
        var errores = this.props.errores || []
        var mostrarFila  = errores.some(function(e) { return e.fila != null && e.fila !== '' })
        var mostrarCampo = errores.some(function(e) { return e.campo != null && e.campo !== '' })

        return (
            <div className="mt-2">
                <div className="text-danger mb-1" style={{ fontWeight: 600 }}>
                    <i className="fa fa-exclamation-triangle mr-1"></i>
                    <FormattedMessage
                        id="periodoPresupuestario.importar.reporte.titulo"
                        defaultMessage="Se encontraron errores. No se guardaron cambios."
                    />
                </div>
                <div style={{ maxHeight: '320px', overflowY: 'auto' }}>
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell><FormattedMessage id="periodoPresupuestario.importar.reporte.sheet" defaultMessage="Sheet" /></TableCell>
                                    {mostrarFila  && <TableCell><FormattedMessage id="periodoPresupuestario.importar.reporte.fila" defaultMessage="Fila" /></TableCell>}
                                    {mostrarCampo && <TableCell><FormattedMessage id="periodoPresupuestario.importar.reporte.campo" defaultMessage="Campo" /></TableCell>}
                                    <TableCell><FormattedMessage id="periodoPresupuestario.importar.reporte.mensaje" defaultMessage="Mensaje" /></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {errores.map(function(error, idx) {
                                    return (
                                        <TableRow key={idx} style={{ backgroundColor: idx % 2 === 0 ? '#fff5f5' : '#fff' }}>
                                            <TableCell style={{ fontSize: '0.82rem', whiteSpace: 'nowrap' }}>{error.sheet || ''}</TableCell>
                                            {mostrarFila  && <TableCell style={{ fontSize: '0.82rem', whiteSpace: 'nowrap' }}>{error.fila || ''}</TableCell>}
                                            {mostrarCampo && <TableCell style={{ fontSize: '0.82rem', whiteSpace: 'nowrap' }}>{error.campo || ''}</TableCell>}
                                            <TableCell style={{ fontSize: '0.82rem', color: '#c62828' }}>{error.mensaje || ''}</TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        )
    }
}

export default PeriodoPresupuestarioImportarReporte
